import { Yup } from "@pharmupp/p3-front-commons"

export const practicalInformationSchema = Yup.object({})
